import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppContentPage, AppContentService, SaveAppContentPage, SellerVerificationOffer } from '../../core/services/app-content.service';
import { httpErrorMessage } from '../../core/utils/http-error-message';

@Component({
  selector: 'app-settings',
  imports: [FormsModule],
  templateUrl: './settings.html',
  styleUrl: './settings.scss',
})
export class Settings implements OnInit {
  private readonly contentService = inject(AppContentService);
  pages: AppContentPage[] = [];
  selectedId: string | null = null;
  loading = true;
  saving = false;
  message = '';
  error = '';
  form: SaveAppContentPage = this.emptyForm();
  verificationOffer: SellerVerificationOffer = { title: 'Get verified badge', description: '', price: 19, currency: 'INR', isEnabled: true };
  savingOffer = false;

  ngOnInit(): void { this.load(); this.contentService.getVerificationOffer().subscribe({ next: (offer) => this.verificationOffer = offer, error: (error) => this.error = httpErrorMessage(error, 'Unable to load verification offer.') }); }

  saveVerificationOffer(): void {
    this.savingOffer = true; this.error = ''; this.message = '';
    this.contentService.updateVerificationOffer(this.verificationOffer).subscribe({
      next: (offer) => { this.verificationOffer = offer; this.savingOffer = false; this.message = 'Verification offer updated in the mobile app.'; },
      error: (error) => { this.savingOffer = false; this.error = httpErrorMessage(error, 'Unable to update verification offer.'); }
    });
  }

  load(): void {
    this.loading = true;
    this.contentService.listAll().subscribe({
      next: (pages) => { this.pages = pages; this.loading = false; },
      error: (error) => { this.error = httpErrorMessage(error, 'Unable to load app content.'); this.loading = false; },
    });
  }

  edit(page: AppContentPage): void {
    this.selectedId = page.id;
    this.form = { slug: page.slug, title: page.title, summary: page.summary, content: page.content, category: page.category, displayOrder: page.displayOrder, isPublished: page.isPublished };
    this.message = ''; this.error = '';
  }

  newPage(): void { this.selectedId = null; this.form = this.emptyForm(); this.message = ''; this.error = ''; }

  save(): void {
    if (!this.form.slug.trim() || !this.form.title.trim() || !this.form.content.trim()) { this.error = 'Slug, title, and content are required.'; return; }
    this.saving = true; this.error = ''; this.message = '';
    const request = this.selectedId ? this.contentService.update(this.selectedId, this.form) : this.contentService.create(this.form);
    request.subscribe({
      next: (page) => { this.saving = false; this.selectedId = page.id; this.message = 'Content saved and mobile data updated.'; this.load(); },
      error: (error) => { this.saving = false; this.error = httpErrorMessage(error, 'Unable to save app content.'); },
    });
  }

  private emptyForm(): SaveAppContentPage {
    return { slug: '', title: '', summary: '', content: '', category: 'Legal', displayOrder: 100, isPublished: true };
  }
}
